import React from 'react';
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";
import Types from "../../constants/Types";

class Address extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
		prefix: PropTypes.string,
		hasCounty: PropTypes.bool,
		notRequired: PropTypes.bool,
		disableSelect: PropTypes.bool,
		crmAvailable: PropTypes.bool,
	};


	// This method dynamically retrieves the correct value for the City Limits Select depending on where the user is within the app.
	getSelectValue = () => {
		const object = this.props.object;
		
		// If the user is within the Customer Edit, use this value.
		if (object && object['city_limits'] !== undefined) {
			return object['city_limits'];
		}
		// If the user is within the Add Acquisition modal, use this value.
		else if (object && object.customers && object.customers.customer_addressess && object.customers.customer_addressess.length > 0) {
			return object.customers.customer_addressess[0].city_limits;
		}
		// If the user is within the Customer Edit, use this value.
		else if (object && object['customer_city_limits'] !== undefined) {
			return object['customer_city_limits'];
		}
		// Default value
		else {
			return '';
		}
	};

	render() {
		let hasCounty = typeof this.props.hasCounty !== 'undefined' ? this.props.hasCounty : true;
		/** @type {Customers_Object} object */
		let object = this.props.object;
		/** @type {Customers_Properties} properties */
		let properties = this.props.properties;
		let {onTextUpdate, onSelectUpdate, prefix} = this.props;
		const selectValue = this.getSelectValue();
		this.props.object.customer_city_limits = selectValue;
		prefix = prefix || '';
		//CRM: force street/city/state/zip required + show Country, only when the customer form passes crmAvailable
		const forceReq = !!this.props.crmAvailable;
		const countryKey = prefix + 'country';
		if (forceReq && !properties[countryKey]) {
			//Keep the CRM field usable when the client's cached API options predate
			//the country property. RestfulObject owns this properties object per form.
			properties[countryKey] = {
				name: countryKey,
				label: 'Country',
				type: 'text',
				settable: true,
				required: false,
				update: true,
			};
		}
		return <div>
			<div className={"row"}>
				<div className={"col-7"}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"Street 1"}
							property={forceReq ? {...(properties[prefix + 'street_1'] || {}), required: true} : properties[prefix + 'street_1']}
							value={object[prefix + 'street_1']}
							error={object[prefix + 'street_1_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
				<div className={"col-5"}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"Street 2"}
							property={properties[prefix + 'street_2']}
							value={object[prefix + 'street_2']}
							error={object[prefix + 'street_2_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
			</div>
			{hasCounty &&
			<div className={"row"}>
				<div className={"col-7"}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"City"}
							property={forceReq ? {...(properties[prefix + 'city'] || {}), required: true} : properties[prefix + 'city']}
							value={object[prefix + 'city']}
							error={object[prefix + 'city_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
				<div className={"col-5"}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"County"}
							property={properties[prefix + 'county']}
							value={object[prefix + 'county']}
							error={object[prefix + 'county_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
			</div>
			}
			{!hasCounty &&
			<div className="form-group">
				<Framework.Elements.TextField
					label={"City"}
					property={properties[prefix + 'city']}
					value={object[prefix + 'city']}
					error={object[prefix + 'city_error']}
					update={onTextUpdate}
					disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
				/>
			</div>
			}
			<div className={"row"}>
				<div className={"col-7"}>
					<div className="form-group" data-id="address-state">
						<Framework.Elements.Select
							shouldLoad={true}
							update={onSelectUpdate}
							property={forceReq ? {...(properties[prefix + 'state'] || {}), required: true} : properties[prefix + 'state']}
							value={object[prefix + 'state']}
							error={object[prefix + 'state_error']}
							model={Types.States._name}
							id={'short'}
							label={"State"}
							labelWidth={5}
							disabled={this.props?.disableSelect || (typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false)}
							nullable={!!this.props.notRequired}
							limit={null}
						/>
					</div>
				</div>
				<div className={"col-5"}>
					<div className="form-group">
						<Framework.Elements.ZipCode
							label={"Zip"}
							property={forceReq ? {...(properties[prefix + 'zip'] || {}), required: true} : properties[prefix + 'zip']}
							value={object[prefix + 'zip']}
							error={object[prefix + 'zip_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
			{this.props.object.customer && (
				<div className="form-group col-7">
					<Framework.Elements.Select
						label={"Reside in City Limits?"}
						shouldLoad={true}
						update={onSelectUpdate}
						objects={[
							{pkey: 'Y', name: 'Yes'},
							{pkey: 'N', name: 'No'},
							{pkey: 'U', name: 'Unknown'},
						]}
						property={properties[prefix + 'city_limits']}
						value={selectValue}
						error={object[prefix + 'city_limits_error']}
						text={'name'}
						nullable={true}
						limit={null}
						disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
					/>
				</div>
			)}
		</div>

		{forceReq && (
			<div className={"row"}>
				<div className={"col-7"}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"Country"}
							property={{...properties[countryKey], name: countryKey, required: true}}
							value={object[countryKey]}
							error={object[countryKey + '_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
			</div>
		)}
	</div>
	}
}

	
export default Framework.Components.withRootState(Address);
